import { ActionTree } from 'vuex'
import { RootState } from '../types'
import { blankCartItem } from './constants'
import State, { CartItem } from './types'
import { v4 as uuidv4 } from 'uuid'

export const actions: ActionTree<State, RootState> = {
  setActiveCartItem(
    { state, commit },
    { cartItem }: { cartItem: CartItem },
  ): any {
    // If the cart Item exists
    if (state.activeCart.items.find((i) => i.id === cartItem.id)) {
      commit('setActiveCartItem', { activeCartItem: { ...cartItem } })
    }
  },

  saveCartItem({ commit, dispatch, state }, { cartItem }: { cartItem: CartItem }): any {
    let id = cartItem.id
    if (cartItem.id) {
      dispatch('updateCartItem', { cartItem })
    } else {
      id = uuidv4()
      commit('saveCartItem', { 'cartItem': { ...cartItem, id } })
    }
    commit('updateCartItemNumbers')
    const index = state.activeCart.items.findIndex(
      (x) => x.id === id,
    )
    if (index >= 0) {
      return state.activeCart.items[index]
    }
  },

  updateCartItem({ commit, state }, { cartItem }: { cartItem: CartItem }): any {
    commit('updateCartItem', { cartItem })
    commit('setActiveCartItem', { activeCartItem: blankCartItem })
    commit('updateCartItemNumbers')
    const index = state.activeCart.items.findIndex(
      (x) => x.id === cartItem.id,
    )
    if (index >= 0) {
      return state.activeCart.items[index]
    }
  },

  deleteCartItem({ commit }, cartItem: CartItem): any {
    commit('deleteCartItem', cartItem)
    commit('setActiveCartItem', { activeCartItem: blankCartItem })
    commit('updateCartItemNumbers')
  },

  updateCartItemQty({ commit }, cartItem: CartItem): any {
    commit('updateCartItemQty', cartItem)
  },

  updateCartItemLocation({ commit }, cartItem: CartItem): any {
    commit('updateCartItemLocation', cartItem)
  },

  setBlankActiveCartItem({ commit }): any {
    commit('setActiveCartItem', { activeCartItem: blankCartItem })
  },

  deleteCartItems({ commit }, cartItems: CartItem[]) {
    commit('deleteCartItems', cartItems)
    commit('updateCartItemNumbers')
  },

  clearCartItems({ commit }) {
    commit('cartItemsCleared')
  },
}
